import * as React from "react";
import Text from "../../../../shared/components/text";
import * as styles from "./styles.css";
var ReviewExtension = function (_a) {
    var children = _a.children;
    return (React.createElement(Text.Article, { className: styles.reviewBodyText }, children));
};
export default ReviewExtension;



//////////////////
// WEBPACK FOOTER
// ./app/modules/pois/patterns/review/reviewExtension.tsx
// module id = Vkxo
// module chunks = 2